import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import loadable from "@loadable/component";
import { LoadHomDataAction } from "../../redux/actions/homeActions";

const GameSection = loadable(() => import("../homepage/GameSection"));
const VideoBanner = loadable(() => import("../../components/VideoBanner"));
const CategoriesCarousel = loadable(() => import("../categories/CategoriesCarousel"));

const Dashboard = () => {
	const AuthState = useSelector((state) => state.Auth);
	const HomeState = useSelector((state) => state.Home);
	const dispatch = useDispatch();
	const [refreshKey, setRefreshKey] = useState(0);

	let isLoggedIn = AuthState?.user && AuthState?.token ? true : false;
	// Returning users have their token in localStorage but not yet in Redux state
	// (Redux token is only set after an auth action completes). Check both.
	const hasToken = isLoggedIn || !!localStorage.getItem("token");
  
  let bannerVideoDataNew;
	let lastCategoryIndex;
	let gameSectionsArr = HomeState?.sections ? HomeState?.sections : [];
	if (gameSectionsArr && gameSectionsArr.length > 0) {
		let lastCategoryData = gameSectionsArr[gameSectionsArr.length - 1];
		if (lastCategoryData) { lastCategoryIndex = lastCategoryData?.id; }
	}

	if (AuthState?.featured && AuthState?.featured.length > 0 ) { 
		bannerVideoDataNew = AuthState?.featured.filter( (el) => el?.app?.video !== "" ); 
	}

	// authKey tracks the user's actual identity so GameSections remount and
	// re-fetch when the user switches from silent (anonymous) to Google login.
	// isSilentLogin is explicitly set to false on CONNECT_ACCOUNT_SUCCESS.
	const isSilentLogin = AuthState?.isSilentLogin;
	const authKey = isSilentLogin ? "silent" : (AuthState?.token ? "auth" : "anon");

	// Re-fetch home data on every mount AND when identity changes (e.g. Google account sync).
	useEffect(() => {
		dispatch(LoadHomDataAction());
	}, [dispatch, authKey, isSilentLogin]);

	// Handle BFCache restore (browser back button on mobile/desktop Chrome)
	useEffect(() => {
		const handlePageShow = (event) => {
			if (event.persisted) {
				dispatch(LoadHomDataAction());
				setRefreshKey((k) => k + 1);
			}
		};
		window.addEventListener("pageshow", handlePageShow);
		return () => window.removeEventListener("pageshow", handlePageShow);
	}, [dispatch]);

	return (
		<>
			<VideoBanner isLoggedIn={isLoggedIn} featured={bannerVideoDataNew} /> 
			{hasToken && ( <GameSection key={`game_section_0_${authKey}_${refreshKey}`} sectionId={2} sectionTitle="Continue Playing" displayViewAll={false} /> )} 
			{gameSectionsArr && gameSectionsArr.length > 0 && gameSectionsArr.map((game, index) => <GameSection key={`game_section_${index + 1}_${authKey}_${refreshKey}`} sectionId={game.id} sectionTitle={game.title} displayViewAll={true} lastCategoryIndex={lastCategoryIndex} /> )} 
			<CategoriesCarousel />
		</>
	);
};

export default Dashboard;
